import React, { Component } from 'react'
import AgentInvoiceTable from '../agentInvoice/agenInvoiceTable'
import Container from '../common/application_container'

export default class AgentInvoiceIndex extends Component {
    render() {
        return (
            <Container title="Agent Invoice" subTitle="Table">
                <AgentInvoiceTable />
            </Container>
        )
    }
}
